module.exports = __webpack_public_path__ + "static/media/create-link-svgrepo-com.ed9a3bd9.svg";